<template>
  <div class="lives-enterinfolist">
    <Row>
      <Col>
        <Button @click="showModel()" type="success">添加</Button>
      </Col>
    </Row>
    <Table border :columns="list" :data="tablelist" :loading="dataloading"></Table>
    <div style="margin: 10px;overflow: hidden">
      <div style="float: right;">
        <Page
          ref="listPage"
          :total="pages.total"
          :current="pages.page"
          :page-size="pages.size"
          show-elevator
          show-total
          @on-change="changePage()"
        ></Page>
      </div>
    </div>
    <!-- 添加的弹出 -->
    <Modal
      v-model="showModalStatus"
      :title="title"
      @on-ok="createOrUpdate('dataInfoValidate')"
      :loading="loading"
    >
      <Form
        :model="dataInfo"
        ref="dataInfoValidate"
        :rules="dataInfoValidate"
        action="javascript:void(0)"
      >
        <FormItem label="名称" prop="name">
          <Input v-model="dataInfo.name" placeholder="请输入名称..."></Input>
        </FormItem>
        <FormItem label="数量">
          <Input v-model="dataInfo.false_num" placeholder="请输入数量..."></Input>
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>

<script>
export default {
  name: "lives-enterinfolist",
  data() {
    return {
      loading: true,
      dataloading: true,
      thumblist: [],
      venueList: [],
      title: "",
      pages: {
        page: 1,
        size: 10,
        total: 0
      },
      formItem: {
        key: ""
      },
      list: [
        {
          title: "Id",
          key: "id",
          fixed: "left",
          width: 90
        },
        {
          title: "名称",
          key: "name",
          width: 200
        },

        {
          title: "数量",
          key: "false_num",
          width: 200
        },
        {
          title: "操作",
          key: "action",
          align: "left",
          fixed: "right",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  style: {
                    marginRight: "8px"
                  },
                  props: {
                    type: "primary",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.detail(params.index, params.row.id);
                    }
                  }
                },
                "编辑"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "error",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.remove(params.index, params.row.id);
                    }
                  }
                },
                "删除"
              )
            ]);
          }
        }
      ],
      tablelist: [],
      dataInfo: {
        name: "",
        false_num: 0
      },
      showModalStatus: false,
      dataInfoValidate: {
        name: [{ required: true, message: "名称必须填写", trigger: "blur" }]
      }
    };
  },
  // 组件
  components: {},
  created: function() {
    // 取数据
    this.getTableList();
  },
  methods: {
    getTableList: function() {
      this.$api.studygroup
        .list({ page: this.pages.page, size: this.pages.size })
        .then(res => {
          this.dataloading = false;
          if (res.code == 200) {
            this.tablelist = res.result.list;
            this.pages.total = res.result.total;
            this.$Message.success(res.msg);
          }
        });
      return;
    },
    // 展开添加
    showModel() {
      this.title = "添加";
      this.dataInfo = {
        name: "",
        false_num: 0
      };
      this.showModalStatus = !this.showModalStatus;
    },
    // 详情
    detail(index, id) {
      this.title = "编辑";
      this.dataInfo = {
        name: "",
        false_num: 0
      };
      this.showModalStatus = !this.showModalStatus;
      this.$api.studygroup.detail({ id: id }).then(res => {
        this.dataInfo = res.result;
      });
    },
    // 添加
    createOrUpdate(name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          if (this.dataInfo.id == null || this.dataInfo.id == 0) {
            this.$api.studygroup.create(this.dataInfo).then(res => {
              if (res.code == 200) {
                this.getTableList();
              }
              this.loading = false;
              this.$nextTick(() => {
                this.loading = true;
              });
              this.showModalStatus = !this.showModalStatus;
            });
          } else {
            this.$api.studygroup.edit(this.dataInfo).then(res => {
              if (res.code == 200) {
                this.getTableList();
              }
              this.loading = false;
              this.$nextTick(() => {
                this.loading = true;
              });
              this.showModalStatus = !this.showModalStatus;
            });
          }
        } else {
          this.$Message.error("请检查输入的信息是否正确！");
          this.loading = false;
          this.$nextTick(() => {
            this.loading = true;
          });
        }
      });
    },
    // 删除
    remove: function(index, id) {
      // 弹出确认框
      this.$Modal.confirm({
        title: "警告",
        content: "<p>此操作不可恢复，三思而后行...</p>",
        onOk: () => {
          this.$api.studygroup.remove({ id: id }).then(res => {
            if (res.code == 200) {
              this.$Message.success(res.msg);
              // this.tablelist.splice(index, 1);
              this.renderTable(1);
            }
          });
        }
      });
    },
    // 修改状态
    changeStatus: function(index, value) {
      var status = value == true ? 1 : 0;
      this.$api.studygroup.status({ id: index, status: status }).then(res => {
        if (res.code == 200) {
          this.$Message.success(res.msg);
        }
      });
    },
    // 翻页
    changePage() {
      this.pages.page = this.$refs["listPage"].currentPage;
      this.renderTable(1);
    },
    // 筛选
    renderTable: function(name) {
      if (name != 1) {
        this.pages.page = 1;
      }
      this.dataloading = true;
      var ps = {
        key: this.formItem.key,
        page: this.pages.page,
        size: this.pages.size
      };
      this.$api.studygroup.list(ps).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.tablelist = res.result.list;
          this.pages.total = res.result.total;
          this.$Message.success(res.msg);
        }
      });
      return;
    }
  }
};
</script>

<style scoped>
</style>